import { downloadFiles, manualDownload } from "../dataLayer/paycor";
import { getPaycorFile, getPaycorPrdaLocalFile } from "../api/paycorV2";

class PaycorManager {

    // Method to handle the downloading of Paycor files based on start and end dates
    async downloadPaycorFiles(startDate: string, endDate: string): Promise<any> {
        try {
            // Call the downloadFiles function to fetch the file paths from the API
            const fileData = await downloadFiles(startDate, endDate);
            console.log("Downloads successful:", fileData);

            // Extract file paths for both files from the response data
            const file1Path = fileData.file1;
            const file2Path = fileData.file2;
            const baseURL = "https://admin.api.wcdp.com"; 
        
            // Construct the full URLs for both files by replacing backslashes with forward slashes
            const file1URL = `${baseURL}${file1Path.replace(/\\/g, "/")}`;
            const file2URL = `${baseURL}${file2Path.replace(/\\/g, "/")}`;

        
            console.log("Full File1 URL:", file1URL);
            console.log("Full File2 URL:", file2URL);
        
            return {file1URL, file2URL};

        } catch (error) {
            // Log any errors that occur during the download process
            console.error("Error during download:", error);

            // Rethrow the error to be handled by the calling code
            throw error;
        }
    }

    // Method to handle the downloading of Paycor files based on start and end dates
    async manualDownloadPaycorFiles(startDate: string, endDate: string, empIDs: string): Promise<any> {
        try {
            // Call the downloadFiles function to fetch the file paths from the API
            const fileData = await manualDownload(startDate, endDate, empIDs);
            console.log("Downloads successful:", fileData);

            // Extract file paths for both files from the response data
            const file1Path = fileData.file1;
            const file2Path = fileData.file2;
            const baseURL = "https://admin.api.wcdp.com"; 
        
            // Construct the full URLs for both files by replacing backslashes with forward slashes
            const file1URL = `${baseURL}${file1Path.replace(/\\/g, "/")}`;
            const file2URL = `${baseURL}${file2Path.replace(/\\/g, "/")}`;
        
            console.log("Full File1 URL:", file1URL);
            console.log("Full File2 URL:", file2URL);

            return {file1URL, file2URL};

        } catch (error) {
            // Log any errors that occur during the download process
            console.error("Error during download:", error);

            // Rethrow the error to be handled by the calling code
            throw error;
        }
    }

    // Method to handle the downloading of Paycor V2 file based on pay period ID
    async downloadPaycorV2File(payPeriodID: string | number): Promise<any> {
        try {
            // Call the getPaycorFile function to download the .zip file
            const response = await getPaycorFile(payPeriodID);
            console.log("Paycor V2 file download successful:", response);

            return response;

        } catch (error) {
            // Log any errors that occur during the download process
            console.error("Error during Paycor V2 download:", error);

            // Rethrow the error to be handled by the calling code
            throw error;
        }
    }

    // Method to handle the downloading of Paycor PRDA Local file based on pay period ID
    async downloadPaycorPrdaLocalFile(payPeriodID: string | number, year: string, week: number): Promise<any> {
        try {
            // Call the getPaycorPrdaLocalFile function to download the .xlsx file
            const response = await getPaycorPrdaLocalFile(payPeriodID, year, week);
            console.log("Paycor PRDA Local file download successful:", response);

            return response;

        } catch (error) {
            // Log any errors that occur during the download process
            console.error("Error during Paycor PRDA Local download:", error);

            // Rethrow the error to be handled by the calling code
            throw error;
        }
    }

}

// Export a single instance of PaycorManager to be used throughout the application
export default new PaycorManager();
